const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  isRecord(value) ? value : undefined;

const getErrorDataMessage = (value: unknown): string | undefined => {
  const data = asRecord(value);
  let messages: unknown[] | undefined;
  if (Array.isArray(data?.Messages)) {
    messages = data.Messages;
  } else if (Array.isArray(data?.messages)) {
    messages = data.messages;
  }
  const joinedMessages = messages
    ?.filter((message): message is string => typeof message === 'string' && message.length > 0)
    .join(' ');

  if (joinedMessages) return joinedMessages;
  return typeof data?.detail === 'string' && data.detail ? data.detail : undefined;
};

export const getRequestErrorMessage = (error: unknown, fallback: string): string => {
  const candidate = asRecord(error);
  const response = asRecord(candidate?.response);

  return (
    getErrorDataMessage(response?.data) ??
    getErrorDataMessage(candidate?.data) ??
    (error instanceof Error && error.message ? error.message : undefined) ??
    (typeof candidate?.message === 'string' && candidate.message ? candidate.message : undefined) ??
    fallback
  );
};
